import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { RootState } from '../../../../../store/rootReducer';
import FolderStructure from '../../../../common/FolderStructure/FolderStructure';
import Loader from '../../../../common/Loader';
import { PDFStateData } from '../../../PDFView/PDFView';

const DataRoom: React.FC = () => {
    const location = useLocation();
    const stateData: PDFStateData = location.state as PDFStateData;

    const loading = useSelector((state: RootState) => state.deal.dataRoomLoading);
    const dataRoom = useSelector((state: RootState) => state.deal.dataRoom);

    return (
        <div>
            {!loading && <FolderStructure dataFiles={dataRoom} isDeal={true} stateData={stateData} />}
            {loading && (
                <div className="flex justify-center items-center">
                    <Loader />
                </div>
            )}
        </div>
    );
};

export default DataRoom;
